import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosRequestConfig } from 'axios'

// 返回除上架字体以为的字体数据
export function getAssetNoShelfFonts(params: {
  tool: number
  page_size: number
}) {
  return request({
    url: `${v2Host}/common/asset/no-shelf-fonts`,
    method: 'get',
    params,
  })
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getCommonComponentList(
  params: {
    type?: number
    page: number
    page_size: number
  },
  config: AxiosRequestConfig,
) {
  return request({
    url: `${v2Host}/common/asset/list`,
    method: 'get',
    params: {
      ...params,
      page_size: 1000,
    },
    ...config,
  })
}

// 返回主标签和资源列表
// http://playable.dev.com:8067/index.html?urls.primaryName=Playturbo%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3#/playsmart/get_ps_common_asset_tag_list_asset
export function getMainTagAssetList(
  params: {
    type: number
    limit?: number
  },
  config: AxiosRequestConfig,
) {
  return request({
    url: `${v2Host}/common/asset-tag/assets`,
    method: 'get',
    params,
    ...config,
  })
}

// 返回辅助标签
// http://playable.dev.com:8067/index.html?urls.primaryName=Playturbo%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3#/playsmart/get_ps_common_asset_tag_list_assist
export function getAssetTag(
  params: {
    type: number
  },
  config: AxiosRequestConfig,
) {
  return request({
    url: `${v2Host}/common/asset-tag/assists`,
    method: 'get',
    params,
    ...config,
  })
}

export function getCommonAssetModelInfo(
  params: {
    name: string
  },
  config?: AxiosRequestConfig,
) {
  return request({
    url: `${v2Host}/common/asset/model-info`,
    method: 'get',
    params,
    ...config,
  })
}
